<template>
  <div class="invoice-list">
    <div class="back">
      <div class="button" @click="$router.go(-1)">&lt; 返回</div>
    </div>
    <h2 class="title">{{ `订单编号：${orderNo} -- 发货单列表` }}</h2>
    <div class="handle-tabe-box">
      <!-- 操作 -->
      <div class="handle-box">
        <el-button @click="createInvoice">创建发货单</el-button>
      </div>
      <div class="table-box">
        <!-- 列表 -->
        <el-table v-loading="tableLoading" :data="tableData" border ref="tableData">
          <el-table-column prop label="序号" width="60" align="center">
            <template slot-scope="scope">
              {{ (listQuery.pageNum - 1) * listQuery.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="orderReceiveId"
            label="发货单编号"
            min-width="80"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="orderShipmentName"
            label="发货单名称"
            min-width="110"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="paymentStatusDesc"
            label="发货单状态"
            min-width="80"
            align="center"
          >
            <template #default="{row}">
              <span>{{ status(row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="发货时间"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" fixed="right" min-width="90" align="center">
            <template #default="scope">
              <el-button @click="goToUrl(scope.row.orderReceiveId)" type="text">查看详情</el-button>
              <el-button
                v-if="
                  (scope.row.shipStatus === 0 && scope.row.inquiryStatus === '') ||
                    (scope.row.shipStatus === -1 && scope.row.inquiryStatus === 2)
                "
                @click="delInvoiceItem(scope.row.orderReceiveId)"
                type="text"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="listQuery.pageNum"
            :total="total"
            :page-size.sync="listQuery.pageSize"
            prev-text="上一页"
            next-text="下一页"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/order";
console.log(api);
export default {
  data() {
    return {
      tableLoading: false,
      tableData: [],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      orderNo: "",
      /* orderId = "",
      purchaseCompanyId: "", */
    };
  },
  created() {
    this.orderNo = this.$route.query.orderNo;
    this.listQuery.orderId = this.$route.query.orderId;
    this.listQuery.purchaseCompanyId = this.$route.query.purchaseCompanyId;
    this.getList(this.listQuery);
  },
  methods: {
    status(row) {
      const { isOnLinePay, companyPayType } = this.$route.query;
      if (row.shipStatus === 0) {
        return "待收货";
      }
      // 已收货
      if (row.shipStatus === 1) {
        if (isOnLinePay === '1' && companyPayType === '1') {
          //判断是不是 在线支付 担保支付
          //0：货款待解冻  7、 货款解冻成功 8、货款解冻失败 6 货款解冻中        0和8一样
          if (String(row.paymentStatus) === "0" || String(row.paymentStatus) === "8") {
            return "货款待解冻";
          } else if (String(row.paymentStatus) === "7") {
            return "完成收货";
          } else {
            return "货款解冻中";
          }
        } else {
          return "完成收货";
        }
      }
      if (row.shipStatus === -1) {
        // 询价状态 0：询价中 1：询价成功  2：询价失败
        if (row.inquiryStatus === 0) {
          return "询价中";
        } else if (row.inquiryStatus === 1) {
          return "询价成功";
        } else if (row.inquiryStatus === 2) {
          return "询价失败";
        }
      }
    },
    delInvoiceItem(orderReceiveId) {
      // purchaseCompanyId: this.$route.query.purchaseCompanyId,
      this.$confirm("您正在操作删除发货单，删除后的发货单无法恢复，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api
            .removeShipInfo({
              orderReceiveId,
              purchaseCompanyId: this.$route.query.purchaseCompanyId,
            })
            .then(res => {
              if (res.code === "200") {
                this.listQuery.pageNum = 1;
                this.getList(this.listQuery);
                this.$message({
                  type: "success",
                  message: "删除发货单成功!",
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    createInvoice() {
      this.$router.push({
        path: "/orderDeliverDetail",
        query: {
          orderId: this.$route.query.orderId,
          purchaseCompanyId: this.$route.query.purchaseCompanyId,
          orderNo: this.$route.query.orderNo,
        },
      });
    },
    // 跳转链接
    goToUrl(orderReceiveId) {
      this.$router.push({
        path: "/invoiceListDetail",
        query: {
          orderReceiveId,
          orderId: this.$route.query.orderId,
          purchaseCompanyId: this.$route.query.purchaseCompanyId,
        },
      });
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },
    async getList(params) {
      const { spplierShipList } = api;
      this.tableLoading = true;
      const res = await spplierShipList({
        ...params,
      });
      if (res.code === "200") {
        this.tableLoading = false;
        const data = res.data;
        console.log("data:", data);
        this.tableData = [...data.records];
        this.total = data.total;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.invoice-list {
  padding: 10px;
  background: #fff;
  .title {
    font-size: 16px;
    margin: 20px 0 0 20px;
  }
  .back {
    margin-left: 20px;
    .button {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #d9d9d9;
      text-align: center;
      &:hover {
        border: 1px solid #2587ff;
        color: #2587ff;
      }
    }
  }

  .handle-tabe-box {
    padding: 20px;
    background: #fff;

    .handle-box {
      margin-bottom: 10px;

      ::v-deep .el-button {
        height: 30px;
      }

      .delete {
        color: #c5c5c5;
      }
    }

    /* 可以提出去 */
    .table-box {
      ::v-deep .el-table {
        .el-table__header {
          thead {
            color: #333;

            th {
              background-color: #f5f5f5 !important;
            }
          }
        }
      }
    }

    .pagination-box {
      text-align: right;
      margin-top: 20px;
      margin-bottom: 0;
      ::v-deep .el-pagination {
        button {
          height: 30px;
          color: #999;
        }
        .el-select {
          .el-input__inner {
            border-radius: 0;
            height: 30px;
          }
        }
        .el-input__inner {
          border-radius: 0;
          height: 30px;
          color: #999;
        }
        .el-select-dropdown__item,
        .el-pagination__jump,
        .el-pagination__total {
          color: #999;
        }
        .el-pager {
          li {
            border-radius: 0;
            border: 1px solid #d9d9d9;
            line-height: 28px;
            text-align: center;
            margin-left: 10px;
            width: 40px;
            height: 30px;
            color: #999;
            &:first-child {
              margin-left: 0;
            }
          }
          .active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
